import { render } from "./pca-form-text-box-virtual-grid-dictionary.vue?vue&type=template&id=1d5702a2"
import script from "./pca-form-text-box-virtual-grid-dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-form-text-box-virtual-grid-dictionary.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-form-text-box-virtual-grid-dictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d5702a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d5702a2', __exports__)) {
    api.reload('1d5702a2', __exports__)
  }
  
  module.hot.accept("./pca-form-text-box-virtual-grid-dictionary.vue?vue&type=template&id=1d5702a2", () => {
    api.rerender('1d5702a2', render)
  })

}


export default __exports__